import React, { useState, useEffect, FC } from 'react';
import { LikeOutlined, DislikeOutlined } from '@ant-design/icons';
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import { likeCourseReview, dislikeCourseReview } from '@/actions/courses';
import { Tooltip } from 'antd';
import { Dispatch } from 'redux';
import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';

type LikeDislikeProps = {
  liked: boolean,
  disliked: boolean,
  id: number,
  likeCount: number,
  dislikeCount: number
}

const LikeDislike: FC<LikeDislikeProps> = ({ liked, disliked, id, likeCount, dislikeCount }) => {
  const dispatch: Dispatch = useDispatch();
  const [likeAction, setLikeAction] = useState<string>(null);
  const [dislikeAction, setDislikeAction] = useState<string>(null);
  const review = useSelector((state: RootStateOrAny) => state.courses?.courseReview);
  const liking: boolean = review?.liking;
  const disliking: boolean = review?.disliking;
  const { isGalaxyZFold }: IBooleanArgs = useWidth();

  useEffect(() => {
    if (liked) {
      setLikeAction('liked');
    }
    if (disliked) {
      setDislikeAction('disliked');
    }
  }, []);

  const handleLikeButtonClick = (): void => {
    if (likeAction === null) {
      dispatch(likeCourseReview(id));
      setLikeAction('liked');
      // If dislike is already clicked
      if (dislikeAction !== null) {
        setDislikeAction(null);
      }
    } else {
      dispatch(likeCourseReview(id));
      setLikeAction(null);
    }
  };
  const handleDislikeButtonClick = (): void => {
    if (dislikeAction !== null) {
      dispatch(dislikeCourseReview(id));
      setDislikeAction(null);
    } else {
      dispatch(dislikeCourseReview(id));
      setDislikeAction('disliked');
      // If like is already clicked
      if (likeAction !== null) {
        setLikeAction(null);
      }
    }
  };
  return (
    <>
      <div className="reply-btn mr-4">
        <Tooltip title={`${likeCount} likes`}>
          <button
            key={'1'}
            className={` ${liking ? 'loading' : ''} ${
              likeAction !== null ? likeAction : ''
            } review-btn mr-2 ${isGalaxyZFold ? 'pr-1 pl-1 pt-0 pb-0' : ''}`}
            onClick={handleLikeButtonClick}
          >
            <LikeOutlined rev="" />
          </button>
        </Tooltip>
        <Tooltip title={`${dislikeCount} dislikes`}>
          <button
            key={'2'}
            className={`
                        ${disliking ? 'loading' : ''} 
                        review-btn mr-2 
                        ${isGalaxyZFold ? 'pr-1 pl-1 pt-0 pb-0' : ''}
                        ${dislikeAction !== null ? dislikeAction : ''} 
                        `}
            onClick={handleDislikeButtonClick}
          >
            <DislikeOutlined rev="" />
          </button>
        </Tooltip>
      </div>
    </>
  );
};

export default LikeDislike;